var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEasyuse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58.731,
    viewBox: "0 0 40 58.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M113.376,117.132a4.975,4.975,0,0,0-1.445.237,4.978,4.978,0,0,0-6.852-2.823,5.019,5.019,0,0,0-4.021-2.034,4.929,4.929,0,0,0-1.122.137V103.69a5.039,5.039,0,0,0-10.076,0v19.166a7.47,7.47,0,0,0-9.683-.562,4.409,4.409,0,0,0-1.026,5.969l6.932,10.4a15.744,15.744,0,0,0,13.126,7.024h3.524a15.759,15.759,0,0,0,14.5-9.561,14.607,14.607,0,0,0,1.179-5.793v-8.164A5.043,5.043,0,0,0,113.376,117.132Zm1.122,13.2a10.709,10.709,0,0,1-.871,4.25,11.846,11.846,0,0,1-10.9,7.189H99.2a11.838,11.838,0,0,1-9.869-5.286l-6.922-10.4a.493.493,0,0,1,.116-.666,3.577,3.577,0,0,1,4.965.632l2.8,3.495a1.958,1.958,0,0,0,3.487-1.222V103.69a1.124,1.124,0,0,1,2.245,0v16.938a1.958,1.958,0,1,0,3.915,0v-3.079a1.122,1.122,0,1,1,2.244,0h0v4.62a1.958,1.958,0,0,0,3.915,0V119.09a1.124,1.124,0,0,1,2.245,0v4.62a1.958,1.958,0,1,0,3.915,0v-1.541a1.122,1.122,0,0,1,2.244,0h0Z",
    transform: "translate(-78.413 -86.956)",
    fill: "#940099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M202.189,9.788a1.958,1.958,0,0,0,1.958-1.958V1.958a1.958,1.958,0,0,0-3.915,0V7.831A1.958,1.958,0,0,0,202.189,9.788Z",
    transform: "translate(-185.681 0)",
    fill: "#940099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M251.364,38.688a1.957,1.957,0,0,0,1.384-.574l4.152-4.152a1.958,1.958,0,0,0-2.72-2.816l-.048.048-4.152,4.152a1.958,1.958,0,0,0,1.384,3.342Z",
    transform: "translate(-228.984 -26.942)",
    fill: "#940099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M121.2,38.471a1.958,1.958,0,0,0,2.768-2.768l-4.152-4.152a1.958,1.958,0,0,0-2.768,2.768Z",
    transform: "translate(-111.946 -27.298)",
    fill: "#940099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M87.453,118.651h5.873a1.958,1.958,0,1,0,0-3.915H87.453a1.958,1.958,0,0,0,0,3.915Z",
    transform: "translate(-84.649 -101.032)",
    fill: "#940099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M265.795,116.694a1.958,1.958,0,0,0,1.958,1.958h5.873a1.958,1.958,0,0,0,0-3.915h-5.873A1.958,1.958,0,0,0,265.795,116.694Z",
    transform: "translate(-243.414 -101.032)",
    fill: "#940099"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyuse);
export default __webpack_public_path__ + "static/media/easyuse.bed4750cd2096419eed05f30ea501356.svg";
export { ForwardRef as ReactComponent };